declare namespace $ {

	export class $mol_link_donate extends $mol_link {
		Icon( ): $mol_icon_gift_outline
		hint( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=donate.view.tree.d.ts.map